import * as R from 'remeda';
import { getIDFromUrl } from '@rossum/api-client';
import { HttpError } from '@rossum/api-client/errors';
import { EditState } from './editState';

export const extractBackendErrorMessage = (
  error: unknown
): string | undefined => {
  if (!(error instanceof HttpError) || !R.isObjectType(error.data)) {
    return undefined;
  }
  const { data } = error;
  if ('detail' in data && typeof data.detail === 'string') {
    return data.detail;
  }
  if (
    'non_field_errors' in data &&
    Array.isArray(data.non_field_errors) &&
    typeof data.non_field_errors[0] === 'string'
  ) {
    return data.non_field_errors[0];
  }
  return undefined;
};

// BE messages can reference pages by their numeric ID inside curly braces,
// e.g. "Pages {11711097, 11711102} are used more than once." — swap those
// IDs for the user-visible page numbers from the original document.
export const humanizePageIdsInMessage = (
  message: string,
  editState: EditState
): string => {
  const pageIdToNumber = new Map(
    [...editState.config.initialParts, ...editState.parts].flatMap(part =>
      part.pages.map(page => [getIDFromUrl(page.url), page.pageNumber] as const)
    )
  );

  return message.replace(/\{([\d,\s]+)\}/g, (whole, ids: string) => {
    const replaced = ids.replace(/\d+/g, idStr => {
      const pageNumber = pageIdToNumber.get(Number(idStr));
      return pageNumber !== undefined ? String(pageNumber) : idStr;
    });
    return replaced === ids ? whole : `{${replaced}}`;
  });
};
